import firebase from 'firebase/app';
import actions from '../constants';
import errorAction from '../../errorAction';

const getOrganizations = () => (dispatch, getState) => {
  dispatch({ type: actions.GET_START });
  const id = getState().getIn(['auth', 'me', 'id'], '');
  return firebase.database().ref('users-organizations').child(id).once('value')
    .then(snapshot => {
      const orgData = snapshot.val();
      dispatch({ type: actions.GET_FINISH, payload: orgData });
    },
    error => dispatch(errorAction(actions.GET_ERROR, error)));
};

export default getOrganizations;



// WEBPACK FOOTER //
// ./src/modules/organizations/actions/getOrganizations.js